import StatusTicker from '@/components/organisms/StatusTicker';
import NavBar from '@/components/organisms/NavBar';
import Footer from '@/components/organisms/Footer';

const MarketingLayout = ({ children }) => (
  <div className="min-h-screen bg-obsidian text-signal">
    <StatusTicker />
    <NavBar />
    <main className="pt-24">{children}</main>
    <Footer />
  </div>
);

export default MarketingLayout;
